var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1358,
    height: 1358,
    viewBox: "0 0 1358 1358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1466_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 678.5,
    cy: 679.5,
    r: 679.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.981 910.984C893.787 910.984 1066.18 921.571 1066.18 935.044C1066.18 948.518 892.824 959.105 679.981 959.105C466.175 959.105 293.781 948.518 293.781 935.044C292.818 921.571 466.175 910.984 679.981 910.984Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.275 560.684C795.556 609.766 602.938 624.202 427.655 603.03L272.597 501.977C257.188 465.406 242.742 426.91 236 399C466.179 547.21 750.291 588.594 907.275 560.684Z",
    fill: "#99CC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.642 603.994C408.38 578.009 377.561 531.814 361.188 500.055C335.185 502.942 295.698 503.904 272.584 502.942L427.642 603.994Z",
    fill: "#004033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1123 399.973C1073.88 585.717 947.717 782.047 766.655 935.069H592.336C570.185 915.821 548.034 896.573 526.846 876.362C806.142 783.009 1039.21 576.092 1123 399.973Z",
    fill: "#0096DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.655 935.054C733.91 914.844 706.944 893.671 679.977 868.648C655.9 894.633 624.118 917.731 593.299 935.054H766.655Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1013.2 520.258C911.115 635.746 755.095 731.987 574.034 782.994L406.456 737.761C392.009 718.513 378.526 699.265 366.006 680.017C570.181 675.205 825.4 658.844 1013.2 520.258Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.039 783.013C545.146 757.99 527.81 743.554 499.881 715.645C470.988 725.269 439.206 732.005 407.424 737.78L574.039 783.013Z",
    fill: "#FF5400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1466_827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1358,
    height: 1358,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconCircle);
export default __webpack_public_path__ + "static/media/app-icon-circle.dcfae1407db367ac7e38477f4b6eaf4b.svg";
export { ForwardRef as ReactComponent };